<ng-container>
  <div #container class="check-box-class component-wrap">
    <mat-label
    #labelContainer
    (click)="toggleTooltip(tooltip)"
    class="{{componentDefinition?.mandatory ? 'mandatory' : ''}} ft-label"
    [title]="componentDefinition?.label">
    {{componentDefinition?.label}}
  </mat-label>

  <div class="labelToolTipContainer"
       #tooltip="matTooltip"
       matTooltip="{{componentDefinition.label}}"
       [matTooltipDisabled]="showToolTip(tooltip, container, labelContainer)">
  </div>

    <mat-checkbox color="primary"
                [id]="componentDefinition?.name + document.documentId"
                  [name]="componentDefinition?.name"
                  [formControl]="formControl"
                  [checked]="fieldValue !== false">
    </mat-checkbox>
  </div>
  <ft-validation-display [model]="document" [componentDefinition]="componentDefinition"></ft-validation-display>
</ng-container>

